// extracted by mini-css-extract-plugin
export default {"product_item":"productItem_product_item__gmtcU","product_img":"productItem_product_img__9lBoB","close_btn":"productItem_close_btn__QW9Js"};